module.exports = __webpack_public_path__ + "a60132ca30d4f929bf73498f63216f89.png";